import React from "react";
import {Box, Card, CardContent, CardMedia, Typography} from "@mui/material";

import anna from "../../images/feedback/anna.PNG";
import andrew from "../../images/feedback/andrew.PNG";
import maria from "../../images/feedback/maria.PNG";
import mariana from "../../images/feedback/mariana.PNG";
import roman from "../../images/feedback/roman.PNG";
import victoria from "../../images/feedback/victoria.PNG";
import yaruna from "../../images/feedback/yaruna.PNG";

import {Swiper, SwiperSlide} from "swiper/react";
import {Autoplay, Navigation} from "swiper/modules";
import {useLanguage} from "../../LanguageContext";
import {sectionTitle} from "../styles/CommonStyles";

function getRandomInt(max) {
    return Math.floor(Math.random() * max);
}

const feedbacks = [
    {
        name: "Mariana",
        photo: mariana,
        text: "Everything about this trip was perfect. The lake, the atmosphere, the food. It felt like stepping into a dream. We had a private boat for the day, which was an experience I’ll never forget. I’ve been twice now, and honestly, I’d go again.",
        date: "January 15, 2025",
    },
    {
        name: "Maria",
        photo: maria,
        text: "I get why people love this place so much. It’s calm, elegant, and just effortlessly beautiful. We spent most of the time by the water, eating, exploring, and just enjoying the views. The private boat ride was a nice touch. A place you don’t want to leave.",
        date: "January 20, 2025",
    },
    {
        name: "Andrew",
        photo: andrew,
        text: "This trip pushed me out of my comfort zone in the best way. Hiking Ben Nevis was tough, but standing at the top made it all worth it. We camped, cooked outside, and just enjoyed being in nature. It was simple but unforgettable.",
        date: "January 22, 2025",
    },
    {
        name: "Victoria",
        photo: victoria,
        text: "Once again, we would like to thank the amazing team for another fabulous holiday. This was exactly what we had hoped for. A trip I’ll never forget.",
        date: "January 22, 2025",
    },
    {
        name: "Roman",
        photo: roman,
        text: "Great experience, great people, and I’d do it all over again.",
        date: "January 22, 2025",
    }, {
        name: "Anna",
        photo: anna,
        text: "It was my first time in Paris, and I totally get the hype now. Everything just feels so classic and full of history. Thanks to AR for making this experience possible.",
        date: "January 22, 2025",
    },
    {
        name: "Yaryna",
        photo: yaruna,
        text: "This was such a cozy and fun trip. Skiing all day, sauna in the evenings, and everything covered in snow. Loved every bit of it.",
        date: "January 22, 2025",
    }
];


const FeedbackSection = () => {
    const {t} = useLanguage();

    return (
        <Box
            sx={{
                width: "100%",
                backgroundColor: '#ffffff',
            }}
        >
            <Box sx={{
                padding: 4,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                textAlign:'center'
            }}>
                <Typography
                    sx={sectionTitle}>
                    {t('label_customer_feedback')}
                </Typography>
                <Box
                    sx={{
                        pt: '20px',
                        width: {
                            xs: '100vw',
                            md: '100vw'
                        },
                        display: 'flex',
                        justifyContent: "center"
                    }}
                >
                    <Swiper
                        slidesPerView={"auto"}
                        pagination={{
                            clickable: true,
                        }}
                        loop={true}
                        initialSlide={getRandomInt(feedbacks.length)}
                        centeredSlides={true}
                        modules={[Autoplay, Navigation]}
                        autoplay={{delay: 3000, disableOnInteraction: true}}
                    >
                        {feedbacks.map((feedback, index) =>
                            <SwiperSlide
                                key={index}
                                style={{
                                    maxWidth: '400px',
                                }}
                            >
                                <Box
                                    sx={{
                                        justifyContent: "center",
                                        width: {
                                            xs: '100%',
                                            md: '400px',
                                        },
                                        // marginLeft: '10%'
                                    }}>
                                    <Card
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            textAlign: "center",
                                            boxShadow: 0,
                                            backgroundColor: "#DDE0DF",
                                            padding: 3,
                                            margin: "16px",
                                            height: '446px',
                                            borderRadius: 0,
                                        }}
                                    >
                                        <CardMedia
                                            component="img"
                                            image={feedback.photo}
                                            alt={feedback.name}
                                            sx={{
                                                width: 150,
                                                height: 150,
                                                borderRadius: "50%",
                                                marginBottom: 2,
                                                border: "3px solid #ddd",
                                            }}
                                        />
                                        <CardContent>
                                            <Typography
                                                sx={{
                                                    fontFamily: 'Jost-Regular',
                                                    fontSize: "22px"
                                                }}
                                            >
                                                {feedback.name}
                                            </Typography>
                                            <Typography
                                                sx={{
                                                    pt: "20px",
                                                    fontFamily: 'Jost-Light',
                                                    fontSize: "17px"
                                                }}>
                                                {feedback.text}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Box>
                            </SwiperSlide>
                        )}

                    </Swiper>
                </Box>
            </Box>
        </Box>

    );
};


export default FeedbackSection;
